import { Controller } from "@hotwired/stimulus"

// Collapsible group rows in the LV import preview table. Rows carry
// data-ref/data-parent-ref from the parsed payload; collapsing a group hides
// all of its descendants. Purely visual — nothing is submitted from here.
export default class extends Controller {
  static targets = ["row", "toggleAllLabel"]

  connect() {
    this.collapsed = new Set()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    const ref = event.currentTarget.closest("[data-ref]").dataset.ref

    if (this.collapsed.has(ref)) {
      this.collapsed.delete(ref)
    } else {
      this.collapsed.add(ref)
    }
    this.render()
  }

  toggleAll(event) {
    event.preventDefault()
    const groupRefs = this.rowTargets
      .filter((row) => row.dataset.kind === "group")
      .map((row) => row.dataset.ref)

    if (this.collapsed.size > 0) {
      this.collapsed.clear()
    } else {
      this.collapsed = new Set(groupRefs)
    }
    this.render()
  }

  render() {
    const parentByRef = new Map(
      this.rowTargets.map((row) => [row.dataset.ref, row.dataset.parentRef]),
    )

    this.rowTargets.forEach((row) => {
      row.classList.toggle("hidden", this.hasCollapsedAncestor(row, parentByRef))

      const chevron = row.querySelector("[data-role='chevron']")
      if (chevron) chevron.classList.toggle("-rotate-90", this.collapsed.has(row.dataset.ref))
    })

    if (this.hasToggleAllLabelTarget) {
      const { expandLabel, collapseLabel } = this.toggleAllLabelTarget.dataset
      this.toggleAllLabelTarget.textContent = this.collapsed.size > 0 ? expandLabel : collapseLabel
    }
  }

  hasCollapsedAncestor(row, parentByRef) {
    let parentRef = row.dataset.parentRef
    while (parentRef) {
      if (this.collapsed.has(parentRef)) return true
      parentRef = parentByRef.get(parentRef)
    }
    return false
  }
}
